import moment from 'moment';

export const dateStart = moment('20/05/2026 8:30', 'DD/MM/YYYY HH:mm');
export const dateEnd = moment('21/05/2026 16:30', 'DD/MM/YYYY HH:mm');

export const dateEndQuizz = moment('21/05/2026 15:30', 'DD/MM/YYYY HH:mm');

export const PRODUCTS_PER_REQUEST = 10;
